import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { ADMIN_DASHBOARD } from "./apiRoutes";

interface UseGetParkDocStatusCountByCommunityIdProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getParkDocStatusCountByCommunityId = async (
  communityId: string,
  year: string
) =>
  await axiosAuth.get(
    `${ADMIN_DASHBOARD}/parked-status?communityId=${communityId}&year=${year}`
  );

const useGetParkDocStatusCountByCommunityId = ({
  communityId,
  year,
  queryParams,
}: UseGetParkDocStatusCountByCommunityIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["park-document-status-count", communityId, year],
    queryFn: () => getParkDocStatusCountByCommunityId(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!year && (queryParams?.enabled ?? true),
  });
};

export default useGetParkDocStatusCountByCommunityId;
